import { render, staticRenderFns } from "./PendingInfo.vue?vue&type=template&id=58221094&scoped=true"
import script from "./PendingInfo.vue?vue&type=script&lang=js"
export * from "./PendingInfo.vue?vue&type=script&lang=js"
import style0 from "./PendingInfo.vue?vue&type=style&index=0&id=58221094&prod&lang=css"
import style1 from "./PendingInfo.vue?vue&type=style&index=1&id=58221094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58221094",
  null
  
)

export default component.exports